import React, { useState } from 'react';
import avatar from '../../assets/images/avatar.png';
import Image from '../../assets/images/image.png';
import { useSelector } from 'react-redux';
import EditProfileModal from './EditProfileModal';
import { useDispatch } from 'react-redux';
import {
    setUser,
    updateCustomerPersonalInfo,
} from '../../redux/users/actionCreator';
import moment from 'moment';
import { Spin } from 'antd';
import { toast } from 'react-toastify';

const PersonalInfo = () => {
    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.user);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    const handleProfileImg = async (e) => {
        let file = e.target.files[0];
        const formData = new FormData();
        formData.append('profile_photo', file);
        let id = userData?.id;
        let message = 'Your profile picture updated successfully';
        setIsUploadingPhoto(true);
        try {
            await dispatch(updateCustomerPersonalInfo(id, formData, message));
        } catch (error) {
            console.error(error);
        } finally {
            setIsUploadingPhoto(false);
        }
    };

    const handleCopyClick = async () => {
        let url = userData
            ? `${window.location.origin}/register-customer?referral=${userData?.id}`
            : window.location.href;
        navigator.clipboard.writeText(url);
        toast.success('Referral link copied');
    };

    return (
        <div 
            className="border col-12 col-md-3 poppins py-4 px-3 bg-white align-self-start" 
            style={{ 
                borderRadius: '16px', 
                borderColor: '#e4e7ec',
                boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.05), 0px 1px 2px rgba(16, 24, 40, 0.03)'
            }}
        >
            {/* Top Avatar & Name Section */}
            <div className="d-flex flex-column align-items-center pb-4" style={{ borderBottom: '1px solid #f2f4f7' }}>
                <div className="position-relative">
                    {isUploadingPhoto ? (
                        <div className="profile_img d-flex align-items-center justify-content-center" style={{ border: '2px solid #f2f4f7' }}>
                            <Spin />
                        </div>
                    ) : (
                        <>
                            <img
                                src={userData?.profile_photo_path || avatar}
                                alt="Avatar"
                                className="profile_img"
                                style={{ 
                                    width: '100px', 
                                    height: '100px', 
                                    borderRadius: '50%', 
                                    objectFit: 'cover',
                                    border: '3px solid #f2f4f7'
                                }}
                            />
                            <label
                                htmlFor="profileImg"
                                className="position-absolute bottom-0 end-0 m-0"
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    src={Image}
                                    alt="camera"
                                    width={32}
                                    height={32}
                                    style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.15))' }}
                                />
                            </label>
                        </>
                    )}
                </div>

                <input
                    id="profileImg"
                    type="file"
                    accept=".jpg , .jpeg ,.png, .svg"
                    className="d-none"
                    onChange={handleProfileImg}
                />

                <span className="mt-3 poppins text-dark fw-semibold f-18 text-capitalize text-center">
                    {userData?.name}
                </span>

                {/* Quick Action Pill Buttons */}
                <div className="d-flex flex-column gap-2 mt-3 w-100 px-2">
                    <button
                        type="button"
                        onClick={toggleModal}
                        className="d-flex align-items-center justify-content-center gap-2 rounded-3 poppins fw-semibold transition-all w-100"
                        style={{
                            border: '1.5px solid #2b5c35',
                            backgroundColor: 'transparent',
                            color: '#2b5c35',
                            cursor: 'pointer',
                            fontSize: '13px',
                            lineHeight: '20px',
                            padding: '8px 16px',
                            whiteSpace: 'nowrap'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#e8f4ec';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                    >
                        <span>Edit Info</span>
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.431 3.01284L8.98758 0.568852C8.90633 0.48758 8.80986 0.42311 8.70369 0.379125C8.59751 0.335139 8.48372 0.3125 8.36879 0.3125C8.25387 0.3125 8.14007 0.335139 8.0339 0.379125C7.92773 0.42311 7.83126 0.48758 7.75 0.568852L1.00649 7.31291C0.924884 7.39387 0.860185 7.49024 0.816154 7.59642C0.772123 7.70261 0.749637 7.81648 0.750004 7.93143V10.3754C0.750004 10.6075 0.842192 10.83 1.00629 10.9941C1.17038 11.1582 1.39294 11.2504 1.625 11.2504H4.06899C4.18394 11.2508 4.29781 11.2283 4.404 11.1843C4.51018 11.1402 4.60655 11.0755 4.6875 10.9939L11.431 4.25041C11.5123 4.16916 11.5768 4.07269 11.6207 3.96652C11.6647 3.86035 11.6874 3.74655 11.6874 3.63163C11.6874 3.5167 11.6647 3.4029 11.6207 3.29673C11.5768 3.19056 11.5123 3.09409 11.431 3.01284ZM4.06899 10.3754H1.625V7.93143L6.4375 3.11893L8.88149 5.56291L4.06899 10.3754ZM9.5 4.94385L7.05602 2.50041L8.36852 1.18791L10.8125 3.63135L9.5 4.94385Z"
                                fill="#2b5c35"
                            />
                        </svg>
                    </button>

                    <button
                        type="button"
                        onClick={handleCopyClick}
                        className="d-flex align-items-center justify-content-center gap-2 rounded-3 poppins fw-semibold transition-all w-100"
                        style={{
                            border: '1.5px solid #667085',
                            backgroundColor: 'transparent',
                            color: '#344054',
                            cursor: 'pointer',
                            fontSize: '13px',
                            lineHeight: '20px',
                            padding: '8px 16px',
                            whiteSpace: 'nowrap'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#f2f4f7';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                    >
                        <span>Referral Link</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            width="12"
                            height="12"
                            fill="#344054"
                        >
                            <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Bottom Info List Section */}
            <div className="pt-4">
                <h6 className="poppins text-dark fw-semibold f-15 mb-3">
                    Personal information
                </h6>
                
                <div className="d-flex flex-column gap-3">
                    {/* Name */}
                    <div className="pb-2" style={{ borderBottom: '1px solid #f2f4f7' }}>
                        <span className="poppins f-12 fw-medium mb-1 d-block" style={{ color: '#667085' }}>
                            Name
                        </span>
                        <span className="poppins f-14 fw-semibold text-dark text-capitalize">
                            {userData.name}
                        </span>
                    </div>

                    {/* Mobile number */}
                    <div className="pb-2" style={{ borderBottom: '1px solid #f2f4f7' }}>
                        <span className="poppins f-12 fw-medium mb-1 d-block" style={{ color: '#667085' }}>
                            Mobile number
                        </span>
                        <span className="poppins f-14 fw-semibold text-dark">
                            {userData?.phone ? userData.phone.replace(/-/g, '') : 'N/A'}
                        </span>
                    </div>

                    {/* Email address */}
                    <div className="pb-2" style={{ borderBottom: '1px solid #f2f4f7' }}>
                        <span className="poppins f-12 fw-medium mb-1 d-block" style={{ color: '#667085' }}>
                            Email address
                        </span>
                        <span className="poppins f-13 fw-semibold text-dark" style={{ wordBreak: 'break-all', lineHeight: '18px' }}>
                            {userData?.email}
                        </span>
                    </div>

                    {/* Date of birth */}
                    <div className="pb-2" style={{ borderBottom: '1px solid #f2f4f7' }}>
                        <span className="poppins f-12 fw-medium mb-1 d-block" style={{ color: '#667085' }}>
                            Date of birth
                        </span>
                        <span className="poppins f-14 fw-semibold text-dark">
                            {userData?.date_of_birth
                                ? moment(userData.date_of_birth).format('DD/MM/YYYY')
                                : 'N/A'}
                        </span>
                    </div>

                    {/* Gender */}
                    <div className="pb-1">
                        <span className="poppins f-12 fw-medium mb-1 d-block" style={{ color: '#667085' }}>
                            Gender
                        </span>
                        <span className="poppins f-14 fw-semibold text-dark text-capitalize">
                            {userData?.gender || 'N/A'}
                        </span>
                    </div>
                </div>
            </div>

            <EditProfileModal
                isModalVisible={isModalVisible}
                handleClose={toggleModal}
            />
        </div>
    );
};

export default PersonalInfo;
